import { Icon } from "@iconify/react";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Modal from "../UI/Modal";
import Alert from "../UI/Alert";
import Loader from "../UI/Loader";
import {
  closeTalentForm,
  openTalentView,
} from "../../store/reducers/plantels/talentsByPlantels.reducer";
import {
  createTalentByPlantelThunk,
  updateTalentByPlantelThunk,
  getTalentByplantelByIdThunk,
} from "../../store/reducers/plantels/plantels.thunks";
import { toast } from "react-toastify";

const TalentByPlantelFormModal = ({ plantelId }) => {
  const dispatch = useDispatch();

  const { formModalOpen, formLoading, formError, formMode, selectedTalent } =
    useSelector((state) => state.talentosByPlantels);
  // console.log(selectedTalent);
  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    if (formMode === "edit" && selectedTalent) {
      reset({
        nombre: selectedTalent.nombre,
        descripcion: selectedTalent.descripcion,
      });
    }

    if (formMode === "create") {
      reset({ nombre: "", descripcion: "" });
    }
  }, [formMode, selectedTalent, reset]);

  const handleClose = () => {
    reset();
    dispatch(closeTalentForm());
  };

  const onSubmit = async (data) => {
    let result;
    let recordId;

    if (formMode === "create") {
      result = await dispatch(
        createTalentByPlantelThunk({ ...data, plantel: plantelId }),
      );
      if (result.meta.requestStatus === "fulfilled") {
        recordId = result.payload.id;
        toast.success("Talento creado");
      }
    } else {
      result = await dispatch(
        updateTalentByPlantelThunk({
          id: selectedTalent.id,
          payload: data,
        }),
      );
      if (result.meta.requestStatus === "fulfilled") {
        recordId = selectedTalent.id;
        toast.success("Talento actualizado");
      }
    }

    if (result.meta.requestStatus === "fulfilled") {
      handleClose();
      await dispatch(getTalentByplantelByIdThunk(recordId));
      dispatch(openTalentView());
    }
  };

  return (
    <Modal
      open={formModalOpen}
      title={formMode === "create" ? "Nuevo talento" : "Editar talento"}
      size="xl"
      onClose={handleClose}
    >
      {formError && <Alert type="danger" message={formError} />}

      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="row g-3">
          <div className="col-12">
            <label className="form-label">
              Nombre <span className="text-danger">*</span>
            </label>
            <input
              className={`form-control ${errors.nombre ? "is-invalid" : ""}`}
              disabled={formLoading}
              {...register("nombre", { required: "El nombre es requerido" })}
            />
            {errors.nombre && (
              <div className="invalid-feedback d-block">
                {errors.nombre.message}
              </div>
            )}
          </div>

          <div className="col-12">
            <label className="form-label">
              Descripción <span className="text-danger">*</span>
            </label>
            <textarea
              rows={3}
              className={`form-control ${
                errors.descripcion ? "is-invalid" : ""
              }`}
              disabled={formLoading}
              {...register("descripcion", {
                required: "La descripción es requerida",
              })}
            />
            {errors.descripcion && (
              <div className="invalid-feedback d-block">
                {errors.descripcion.message}
              </div>
            )}
          </div>
        </div>

        <div className="d-flex justify-content-end gap-2 mt-4">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={handleClose}
            disabled={formLoading}
          >
            Cancelar
          </button>

          <button
            type="submit"
            className="btn btn-primary d-flex align-items-center gap-2"
            disabled={formLoading}
          >
            {formLoading ? (
              <>
                <Loader
                  type="spinner"
                  text="Guardando..."
                  size="sm"
                  delay={0}
                />
              </>
            ) : (
              <>
                <Icon icon="mdi:content-save" width="20" />
                {formMode === "create" ? "Crear" : "Actualizar"}
              </>
            )}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default TalentByPlantelFormModal;
